import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import VerbaScholaStudentShell from '../component/VerbaScholaStudentShell';
import VerbaScholaStudentCoursePage from './VerbaScholaStudentCoursePage';
import VerbaScholaStudentCoursesPage from './VerbaScholaStudentCoursesPage';
import VerbaScholaStudentFeedbackPage from './VerbaScholaStudentFeedbackPage';
import VerbaScholaStudentHomePage from './VerbaScholaStudentHomePage';
import VerbaScholaStudentLessonPage from './VerbaScholaStudentLessonPage';
import VerbaScholaStudentProfile from './VerbaScholaStudentProfile';
import VerbaScholaStudentPronunciationPage from './VerbaScholaStudentPronunciationPage';
import VerbaScholaStudentSettingsPage from './VerbaScholaStudentSettingsPage';
import { VerbaScholaStudentHelpPage } from './VerbaScholaHelpPage';
import VerbaScholaStudentAccountPage from './VerbaScholaStudentAccountPage';

/** Persistent student shell and route composition; page data stays in each page. */
export default function VerbaScholaStudentApp() {
    const { path } = useRouteMatch();
    return <VerbaScholaStudentShell>
        <Switch>
            <Route exact path={`${path}/profile`} component={VerbaScholaStudentProfile} />
            <Route exact path={`${path}/settings`} component={VerbaScholaStudentSettingsPage} />
            <Route exact path={`${path}/help`} component={VerbaScholaStudentHelpPage} />
            <Route exact path={`${path}/account`} component={VerbaScholaStudentAccountPage} />
            <Route exact path={[`${path}/feedback/:attemptId`, `${path}/feedback`]} component={VerbaScholaStudentFeedbackPage} />
            <Route exact path={`${path}/courses`} component={VerbaScholaStudentCoursesPage} />
            <Route exact path={`${path}/pronunciation`} component={VerbaScholaStudentPronunciationPage} />
            <Route path={`${path}/course/:courseId/lesson/:lessonId`} render={({ match, location }: { match: { url: string }; location: { search: string } }) => <VerbaScholaStudentLessonPage key={`${match.url}-${new URLSearchParams(location.search).get('run') ?? 0}`} />} />
            <Route exact path={`${path}/course/:courseId`} component={VerbaScholaStudentCoursePage} />
            <Route exact path={path} component={VerbaScholaStudentHomePage} />
            <Redirect to={path} />
        </Switch>
    </VerbaScholaStudentShell>;
}
